<template>
  <div>
    <v-navigation-drawer
      id="core-navigation-drawer"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      :right="$vuetify.rtl"
      color="#263238"
      mobile-breakpoint="960"
      app
      width="280"
      v-bind="$attrs"
    >
      <v-list>
        <v-list-item>
          <v-img
            :src="logo"
            width="100"
            height="70"
            class="dbs-logo"
          />
        </v-list-item>
        <div
          v-if="anyActiveCheckIns"
          class="clock-div"
        >
          <span class="clock-span">Remote Work</span> (<check-in-clock
            class="work-clock"
          />) <br>
          <span
            class="site-name"
          >
            {{ activeCheckInDetails.site.name }}
          </span>
        </div>
        <v-divider />
      </v-list>
      <v-list>
        <v-list-item
          v-for="item in drawerItems"
          :key="item.title"
          link
          class="drawer-items"
          @click="takeToPage(item.route)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      id="app-bar"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      dark
      absolute
      app
      color="#263238"
      flat
    >
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4"
      >
        <v-app-bar-nav-icon
          style="color:white;"
          @click.stop="drawer = !drawer"
        />
      </v-toolbar-title>
      <div class="flex-grow-1" />
      <v-btn
        icon
        class="my-logout-button-style"
        color="#ECEFF1"
        @click="manualCheckout()"
      >
        <v-icon
          color="#ECEFF1"
          size="30"
        >
          mdi-account-arrow-left-outline
        </v-icon>
      </v-btn>
      <v-btn
        icon
        class="my-logout-button-style"
        color="#ECEFF1"
        @click="logout()"
      >
        <v-icon
          color="#ECEFF1"
          size="25"
        >
          mdi-logout
        </v-icon>
      </v-btn>
      <v-btn
        icon
        large
        @click="takeToProfile()"
      >
        <v-avatar
          size="32px"
          item
        >
          <v-img
            :src="avatarImg"
            alt="Vuetify"
          />
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <alert-dialog
      v-if="showLogoutAlert"
      :title="'Confirm Logout'"
      :message="'Are you sure you want to logout of the app ?'"
      @closed="showLogoutAlert = false"
      @confirmed="logoutConfirmed()"
    />
    <checkout-alert
      v-if="showCheckoutAlert"
      :title="'Manual Check-Out'"
      :message="'Are you sure you want to do a manual check-out from this site ?'"
      @closed="showCheckoutAlert = false"
      @confirmed="checkoutConfirmed()"
    />
    <manual-checkout-reason
      v-if="showReasonForm"
      @closed="showReasonForm = false"
      @manual-checkout="toCheckoutProcess()"
    />
    <centre-spinner
      :loading="loading"
    />
  </div>
</template>

<script>
import CheckInClock from '../process/Checkin/CheckInClock.vue';
import Constants from 'src/constants';
import AlertDialog from 'src/views/components/AlertDialog.vue';
import spinner from 'src/views/components/SpinnerCentre';
import ManualCheckoutReason from 'src/views/process/ManualCheckoutReason.vue';

export default {
  name: 'AppHeader',
  components: {
    'check-in-clock': CheckInClock,
    'alert-dialog': AlertDialog,
    'centre-spinner': spinner,
    'checkout-alert': AlertDialog,
    'manual-checkout-reason': ManualCheckoutReason,
  },
  data: () => ({
    drawerItems: [
      { title: 'Home', icon: 'mdi-home', route: '/home' },
      { title: 'My Profile', icon: 'mdi-account', route: '/user' },
      { title: 'Activity', icon: 'mdi-bell', route: '/activity' },
      { title: 'Documents', icon: 'mdi-cloud-upload', route: '/uploads' },
    ],
    avatarImg: require('@/assets/img/5s.png'),
    dialog: false,
    drawer: null,
    logo: require('@/assets/img/dbsLogoSmall.png'),
    showLogoutAlert: false,
    loading: false,
    showCheckoutAlert: false,
    showReasonForm: false,
  }),
  computed: {
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    anyActiveCheckIns () {
      if (Object.keys(this.activeCheckInDetails).length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    takeToPage (route) {
      var userExist = localStorage.getItem('user');
      if (userExist === null && route !== '/') {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please sign in before proceeding.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.$router.push(route);
    },
    takeToProfile () {
      var userExist = localStorage.getItem('user');
      if (userExist === null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please sign in before proceeding.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.$router.push({ name: 'User Profile' });
    },
    logout () {
      var checkInId = localStorage.getItem('checkIn');
      var userExist = localStorage.getItem('user');
      if (userExist === null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Already signed out.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      if (checkInId !== null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please checkout first.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.showLogoutAlert = true;
    },
    async logoutConfirmed () {
      this.loading = false;
      this.showLogoutAlert = false;
      this.$router.push({ name: 'Logout' });
    },
    manualCheckout () {
      var checkInId = localStorage.getItem('checkIn');
      var userExist = localStorage.getItem('user');
      if (userExist === null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please sign in first.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      if (checkInId === null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please check-in first.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.showCheckoutAlert = true;
    },
    checkoutConfirmed () {
      this.showCheckoutAlert = false;
      this.showReasonForm = true;
    },
    toCheckoutProcess () {
      this.showReasonForm = false;
      const currentCheckInType = this.activeCheckInDetails.type;
      const siteId = this.activeCheckInDetails.site.id;
      this.$router.push(`${siteId}/check-out/${currentCheckInType}`);
    },
  },
};
</script>
<style scoped>
.dbs-logo {
  margin-bottom: 10px;
}
.work-clock {
  color: #B0BEC5;
  font-size: 18px !important;
}
.clock-div {
  margin-bottom: 15px;
  text-align: center;
}
.clock-span {
  font-size: 18px !important;
  color: #CFD8DC;
  font-family: 'Times New Roman', Times, serif;
  font-weight: 800;
}
.btn-style {
   margin-top: 10px;
}
.checkout-btn {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #CFD8DC;
}
#app-bar {
  border-bottom: 1px solid #B0BEC5 !important;
}
.my-logout-button-style {
  color: #ECEFF1;
  margin-top: 5px;
}
.drawer-items {
  color: #ECEFF1;
  font-family: 'Times New Roman', Times, serif;
}
.site-name {
  font-size: 16px !important;
  color: #CFD8DC;
  font-family: 'Times New Roman', Times, serif;
  font-weight: 800;
  text-transform: capitalize;
}
</style>
